import { Component, OnInit } from '@angular/core';
import { NavService, Menu } from '../../services/nav.service';
import { Router } from '@angular/router';
import { UtilsService } from 'src/app/utils.service';
import { UtilsDataService } from 'src/app/services/utils-data.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  public menuItems: Menu[];
  public profileData: any = {};

  constructor(
    private router: Router,
    public navServices: NavService,
    private utilsService: UtilsService,
    private utilsDataService: UtilsDataService,

  ) {

      this.utilsService.profileActionData.subscribe((data: any) => {
  console.log("RRRRR", data);
  this.profileData = data.profileData;
  console.log("pppppp====", this.profileData);

  const modules = this.profileData?.vendorApplicationModules ?? {};

const filteredMenu = this.navServices.VENDORMENUITEMS.filter(menu => {

  // Hide "Post a Job" unless jobs === 'Y'
  if (menu.type === 'jobs' && modules.jobs !== 'Y') {
    return false;
  }

  // Case: jobs = Y, matri != Y → hide bureau-profile
  if (modules.jobs === 'Y' && modules.matri !== 'Y') {
    return menu.type !== 'bureau-profile';
  }

  // Case: jobs != Y, matri = Y → hide company-profile
  if (modules.jobs !== 'Y' && modules.matri === 'Y') {
    return menu.type !== 'company-profile';
  }

  // Case: jobs = Y, matri = Y → show everything
  if (modules.jobs === 'Y' && modules.matri === 'Y') {
    return true;
  }

  // Default: show everything else
  return true;
});
  if (this.profileData.role === 'VENDOR') {
    this.navServices.items.next(filteredMenu); // use filteredMenu here
  } else if (this.profileData.role === 'VENDOR_EMP') {
    this.navServices.items.next(this.navServices.VENDOREMPMENUITEMS);
  } else if (this.profileData.role === 'AGENT') {
    this.navServices.items.next(this.navServices.BUSINESSPARTNERMENUITEMS);
  } else if (this.profileData.role === 'INTERVIEWER') {
    this.navServices.items.next(this.navServices.INTERVIEWERMENUITEMS);
  } else {
    this.navServices.items.next(this.navServices.MENUITEMS);
  }
});


    /* this.utilsService.profileActionData.subscribe((data: any) => {
      console.log("RRRRR", data);
      this.profileData = data.profileData;
      console.log("pppppp====", this.profileData);

      const filteredMenu = this.navServices.VENDORMENUITEMS.filter(menu => {

        const modules = this.profileData?.vendorApplicationModules ?? {};
        if (modules.jobs === 'Y' && modules.matri !== 'Y') {
          return menu.type !== 'bureau-profile';
        }

        if (modules.matri === 'Y' && modules.jobs !== 'Y') {
          return menu.type !== 'company-profile' && menu.type !== 'jobs';
        }

        // if (this.profileData.vendorApplicationModules?.jobs === 'Y' && this.profileData.vendorApplicationModules?.matri !== 'Y') {
        //   return menu.type !== 'bureau-profile';
        // }
        // if (this.profileData.vendorApplicationModules?.matri === 'Y' && this.profileData.vendorApplicationModules?.jobs !== 'Y') {
        //   return menu.type !== 'company-profile' && menu.type !== 'jobs';
        // }
        // if (menu.type === 'profile') {

        // }
        // if (menu.type === 'plans') {

        // }

        // Default: Show other items
        if (modules.jobs === 'Y' && modules.matri === 'Y') {
          return menu.type !== 'jobs';
        }
      });

      if (this.profileData.role === 'VENDOR') {
        this.navServices.items.next(this.navServices.VENDORMENUITEMS);
      } else if (this.profileData.role === 'VENDOR_EMP') {
        this.navServices.items.next(this.navServices.VENDOREMPMENUITEMS);
      } else if (this.profileData.role === 'AGENT') {
        this.navServices.items.next(this.navServices.BUSINESSPARTNERMENUITEMS);
      } else if (this.profileData.role === 'INTERVIEWER') {
        this.navServices.items.next(this.navServices.INTERVIEWERMENUITEMS);
      }
      else {
        this.navServices.items.next(this.navServices.MENUITEMS);
      }
    }); */

    this.navServices.items.subscribe(menuItems => {
      this.menuItems = menuItems;
    });

    this.router.events.subscribe(() => {
      this.navServices.mainMenuToggle = false;
    });

  }

  ngOnInit(): void {
  }

  mainMenuToggle(): void {
    this.navServices.mainMenuToggle = !this.navServices.mainMenuToggle;
  }

  // Click Toggle menu (Mobile)
  toggletNavActive(item) {
    item.active = !item.active;
  }

  /* goTo(link: any) {
    this.router.navigate([link])
    this.utilsDataService.jobDetails = {};
    this.utilsDataService.detailViewStatus = false
  } */

    goTo(link: any, menuItem?: Menu) {
  const modules = this.profileData?.vendorApplicationModules ?? {};

  if (menuItem?.type === 'plans') {
    if (modules.jobs === 'Y' && modules.matri !== 'Y') {
      this.router.navigate([link], { queryParams: { tab: 'JOBS' } });
    } else if (modules.jobs !== 'Y' && modules.matri === 'Y') {
      this.router.navigate([link], { queryParams: { tab: 'MATRI_VENDOR' } });
    } else if (modules.jobs === 'Y' && modules.matri === 'Y') {
      this.router.navigate([link], { queryParams: { tab: 'JOBS' } });
    }
  } else {
    this.router.navigate([link]);
  }

  this.utilsDataService.jobDetails = {};
  this.utilsDataService.detailViewStatus = false;
}


}
